import apiClient from '../../api/apiClient';

export const multipleDomainScanApi = async (data) => {
  const response = await apiClient.post('/partners/oem-partners/multiple-scan', data);
  return response.data;
};